export const typePolicies = {
  Home: { merge: true },
  Company: { merge: true },
  Governance: { merge: true },
  Career: { merge: true },
};
